import { useField } from "formik"
import styles from "../../styles/Form-Inputs.module.css"
import refStyles from "../../styles/Referrals.module.css"
import { Rating } from "primereact/rating"
import RefTextAreaInput from "./RefTextAreaInput"
import { Button } from "primereact/button"

const CustomRating = ({ name, values, isSubmitting }) => {
  const [field, meta, helpers] = useField(name)
  let ratingDescription = ""

  const value = field.value ?? values.score
  switch (value) {
    case 1:
      ratingDescription = "Very dissatisfied"
      break
    case 2:
      ratingDescription = "Dissatisfied"
      break
    case 3:
      ratingDescription = "Neither satisfied nor dissatisfied"
      break
    case 4:
      ratingDescription = "Satisfied"
      break
    case 5:
      ratingDescription = "Very satisfied"
      break
    default:
      ratingDescription = ""
  }

  return (
    <>
      <div
        className={styles.field}
        style={{ height: "100%", marginTop: "10px" }}
      >
        <label
          className={`${refStyles.rankingLabel} ${
            values?.score > 0 && refStyles.rankingLabelSm
          }`}
        >{`Satisfaction rating:  ${ratingDescription}`}</label>
        <div style={{ height: "100%", marginTop: "10px" }}>
          <Rating
            value={field.value ? field.value : values.score}
            cancel={false}
            className={
              meta.touched && meta.error ? "p-invalid" : refStyles.rating
            }
            onChange={(e) => {
              if (values?.id === 0) {
                helpers.setValue(e.target.value)
              }
            }}
            disabled={values.id !== 0}
          ></Rating>
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </div>
      </div>
      <div className={refStyles.ratingField}>
        <div style={{ width: "100%" }}>
          <RefTextAreaInput
            name="note"
            label="Note"
            disabled={values.id !== 0}
            value={values?.note}
          />
        </div>
        {values.id === 0 ? (
          <Button
            label="Submit"
            type="submit"
            icon={isSubmitting && "pi pi-spin pi-spinner"}
            className={`${refStyles.ratingButton}`}
            disabled={isSubmitting}
          />
        ) : null}
      </div>
    </>
  )
}
export default CustomRating
